import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { Menu, MenuItems } from '../../../shared/menu-items/menu-items';
import { TokenStorageService } from '../../../services/token-storage/token-storage.service';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: []
})
export class AppSidebarComponent implements OnDestroy {
  mobileQuery: MediaQueryList;

  private _mobileQueryListener: () => void;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    public tokenStorageService: TokenStorageService,
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  listMenu(): Menu[] {
    return this.menuItems.getMenuitem(this.tokenStorageService.getUser());
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  goToLink(url: string) {
    window.open(url, "_blank");
  }

  getLink(menu: Menu) {
    if (menu.state === 'profile-menu' || menu.state === 'profile') {
      return `${menu.state}/${this.tokenStorageService.getId()}`;
    }
    if (menu.state === 'approval-cuti') {
      return 'cuti/approval';
    }
    return menu.state;
  }
}
